<template>
  <p>Edit event here</p>
</template>

<script>
export default {
  props: ['event'],
};
</script>
